import styled from "styled-components";

export const Container = styled.div`
	@media screen and (min-width: 0px) {
		section.content {
			min-height: calc(100vh - 90px);
			display: flex;
			flex-direction: column;
			align-items: center;

			.scan {
				width: 256px;
				height: 256px;
				margin-bottom: 3em;

				background-image: url(${require("@/assets/img/scan-bg.svg")});
				background-repeat: no-repeat;
				background-size: contain;

				& section {
					padding: 1em;
					display: flex;
					height: 100%;
					align-items: center;
					justify-content: center;
					overflow: hidden;

					video {
						object-fit: cover;
						height: 100%;
					}
				}

				.cam-blocked {
					cursor: pointer;
					width: 224px;
					height: 240px;
					display: flex;
					align-items: center;
					justify-content: center;
					text-align: center;
					padding: 10px;
					border: 1px solid #d6d6d6;
					background-color: #eae7e7;
					background-image: url(${require("@/assets/img/no-pictures@2x.png").default});
					background-repeat: no-repeat;
					background-position: center;
					background-blend-mode: overlay;
					background-size: 126px;
				}
			}

			.block-message {
				&__text {
					font-size: 1em;
					text-align: center;

					span {
						cursor: pointer;
						font-weight: bold;
						/* text-transform: uppercase; */
					}
				}
			}

			.form {
				display: flex;
				flex-direction: column;
				align-items: center;
				width: 100%;
				margin-bottom: 4em;

				input {
					width: 85%;
					height: 40px;
					border: 0;
					border-bottom: 1px solid #333;
					text-align: center;
					margin-bottom: 1.5em;
				}

				button {
					min-width: 218px;
					text-transform: inherit;
					font-weight: bold;
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		display: flex;

		aside {
			flex-basis: 50%;
			display: flex;
			flex-direction: column;
			align-items: center;

			img {
				max-height: 710px;
			}
		}

		section.content {
			flex-basis: 50%;
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			/* background-image: url(${require("@/assets/img/labyes.png")
		.default});
			background-repeat: no-repeat;
			background-position: right bottom; */

			.qrcode {
				svg {
					width: 210px;
					height: 210px;
				}
			}

			.form {
				max-width: 512px;
			}
		}
	}
`;
